import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5.25 12H11M5.25 12V7.75M5.25 12L5.25 16.25M11 12V7.75M11 12V16.25" strokeLinecap="square" vectorEffect="non-scaling-stroke" />
		<Path d="M19.25 17V12.75M19.25 9V12.75M15 7V7.5L13.75 12.75H19.25" vectorEffect="non-scaling-stroke" />
	</SVG>
);
